import styled from 'styled-components';

const Label = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: ${props => props.child ? "14px" : "16px"};
  color: #FFFFFF;
  margin-left: 15px;
`;

export default Label;